import { EMPTY_FIELD } from 'constants/emptyField';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { FunctionField, NumberField } from 'shared/react-admin/Fields';
import { CommissionStep } from 'types/embedded/commission';

export const CommissionsTabsLadderStep: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <CardTable>
      <TableRowWrapper label="Номер ступени">
        <NumberField emptyText={EMPTY_FIELD} label="Номер ступени" source="stepNumber" />
      </TableRowWrapper>
      <TableRowWrapper label="Порог от-до">
        <FunctionField
          emptyText={EMPTY_FIELD}
          label="Порог от-до"
          render={(record: CommissionStep) =>
            `${record?.thresholdFrom || 0} - ${record?.thresholdTo || '∞'}`
          }
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.percent')}>
        <FunctionField
          label="Процент"
          render={(record: CommissionStep) => {
            if (!record?.commissionRate.percent) {
              return EMPTY_FIELD;
            }
            return `${record?.commissionRate.percent}%`;
          }}
          source="commissionRate.percent"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.fixed')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.fixed')}
          source="commissionRate.fix"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.max')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.max')}
          source="commissionRate.max"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.min')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.min')}
          source="commissionRate.min"
        />
      </TableRowWrapper>
    </CardTable>
  );
};
